import type { CookieStore, CookieOptions } from './cookieStorageAdapter';

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  try {
    const match = document.cookie.match(new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

function setCookie(name: string, value: string, options?: CookieOptions): void {
  if (typeof document === 'undefined') {
    return;
  }
  try {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    if (options?.path) {
      cookie += `; path=${options.path}`;
    }
    if (options?.maxAge !== undefined) {
      cookie += `; max-age=${options.maxAge}`;
    }
    if (options?.domain) {
      cookie += `; domain=${options.domain}`;
    }
    if (options?.secure) {
      cookie += '; secure';
    }
    if (options?.sameSite) {
      cookie += `; samesite=${options.sameSite}`;
    }
    document.cookie = cookie;
  } catch {
    // Safari private mode may throw
  }
}

function removeCookie(name: string, options?: CookieOptions): void {
  if (typeof document === 'undefined') {
    return;
  }
  try {
    let cookie = `${encodeURIComponent(name)}=; max-age=0`;
    if (options?.path) {
      cookie += `; path=${options.path}`;
    }
    if (options?.domain) {
      cookie += `; domain=${options.domain}`;
    }
    document.cookie = cookie;
  } catch {
    // Safari private mode may throw
  }
}

export const webCookieStore: CookieStore = {
  get: getCookie,
  set: setCookie,
  remove: removeCookie,
};
